module.exports = __webpack_public_path__ + "img/2.e64ee9ff.jpg";